import React from "react";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Navigate,
	useNavigate,
	useParams,
	useSearchParams,
} from "react-router-dom";

import PageLoader from "../../Components/loaders/PageLoader/PageLoader";
import ResetPasswordPopup from "../../Components/Popups/ResetPasswordPopup/ResetPasswordPopup";
import {
	loginUser,
	logout,
	byPassUserByLMS,
	byPassUserByOrbit,
	clearAuthSliceStates,
} from "../../redux/authentication/authSlice";
import Cookies from "js-cookie";
import { useEffect } from "react";
import Image from "../../Components/Image/Image";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import SignIn from "../../assets/lottie/SignIn.json";
import classInSvg from "../../assets/svg/classIn.svg";
import chatContact from "../../assets/svg/hoverContact.svg";
import playStore from "../../assets/img/playstore.png"
import mainlogo from "../../assets/img/mainlogo.svg";
import Logo from "../../assets/svg/logo.svg";

import { TOAST_POSITION, TOAST_AUTOCLOSE } from "../../utils/toastConfig";
import { BloomBergLogo, BloomBergLogoBlack, CoworkLogo, CoworkLogoText, MakersLogoBlack, EduspaceLogo } from "../../MakersV2/Theme/Icons";
import { Button, Flexbox, InputField, LoginWrapper, StyledLink, WrapperBox } from "../../MakersV2/Theme/GlobalStyles";
import { Text } from "../../MakersV2/Theme/Typography";
import { globalTheme } from "../../MakersV2/Theme/Theme";
import Wave from "../../assets/img/Wave.png"
import SignInLeft from "../../assets/img/signInLeft.png"
import bloombergSignInLeft from "../../assets/img/bloombergSignInLeft.png"
import eduspaceSignInLeft from "../../assets/img/eduspaceSignInLeft.png"
import coworkSignInLeft from "../../assets/img/coworkSignInLeft.png"

// The Makers Lab art (signInLeft.png) is 893x647. The Cowork / Eduspace /
// Bloomberg exports are the SAME aspect ratio but at 4x scale (3570x2586), and
// these are bare <img> tags with no CSS size — so the browser laid them out at
// their intrinsic width, overflowing the page and pushing the sign-in form out
// of view. Pin every variant to the Makers Lab reference width and let the
// height follow the aspect ratio (the hi-res source still helps on retina).
const SIGNIN_ART_STYLE = {
	width: "100%",
	maxWidth: 893,
	height: "auto",
	minWidth: 0,
	flexShrink: 1,
	objectFit: "contain",
};

// The sign-in art is hidden below 768px, but `display: none` still downloads
// the image — and the Cowork / Eduspace / Bloomberg exports are 3570x2586
// (~3 MB each). Skip rendering it entirely on phones instead, so the login
// screen doesn't cost 3 MB on mobile data. Matches the .loginArt breakpoint.
const useHideSignInArt = () => {
	const [hide, setHide] = useState(
		() => typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches
	);
	useEffect(() => {
		const mq = window.matchMedia("(max-width: 768px)");
		const onChange = (e) => setHide(e.matches);
		setHide(mq.matches);
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, []);
	return hide;
};

const Login = () => {
	const formObject = { email: "", password: "" };
	const [formData, setFormData] = useState(formObject);
	const [errors, setErrors] = useState({ email: "", password: "" });
	const [resetPopup, setResetPopup] = useState(false);
	const [type, setType] = useState(true);
	const hideSignInArt = useHideSignInArt();
	const [lmsToken, setLmsToken] = useSearchParams();
	const [orbitToken, setOrbitToken] = useSearchParams();
	// console.log(lmsToken.get("lmsToken2"));
	const historyAction = window.history.action;
	if (historyAction === "POP") {
		Cookies.remove("token");
	}

	// URL-based theme detection
	const currentUrl = window.location.hostname;
	const isClassroomTheme = currentUrl.includes('classroom.mastersunion.org') || currentUrl.includes('classroom')
	// || currentUrl.includes('localhost');
	const isCoworkTheme = currentUrl.includes('cowork.mastersunion.org')
	// || currentUrl.includes('localhost');
	const isMakersLabTheme = currentUrl.includes('makerslab.mastersunion.org') || currentUrl.includes('makersv2') || currentUrl.includes('127.0.0.1')
	// || currentUrl.includes('localhost');
	const isBloombergTheme = currentUrl.includes('bloomberg') || currentUrl.includes('bmb')
	|| currentUrl.includes('localhost');

	
	const lmsProduct = "coWork";
		// lmsToken.get("appName") ||
		// (currentUrl.includes("bloomberg") || currentUrl.includes("bmb") ? "bmb" : undefined);
	const {
		isAuthSliceFetching,
		isAuthSliceSuccess,
		isAuthSliceError,
		authSliceErrorMessage,
		resetRequired,
		isResetSliceSuccess,
		byPassMsg
	} = useSelector((state) => state.authentication);
	console.log(isAuthSliceSuccess,'test1')
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const token = Cookies.get("token");

	const clearAuthCookies = () => {
		Cookies.remove("token");
		Cookies.remove("loginData");
		Cookies.remove("userEmail");
		Cookies.remove("roles");
		Cookies.remove("myCookie");
	};

	useEffect(() => {
		const hasLmsToken = lmsToken.get("lmsToken");
		const hasOrbitToken = orbitToken.get("orbitToken");

		if (hasLmsToken) {
			clearAuthCookies();
			// dispatch(logout());
			const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
			if (window.innerWidth < 600 && !isSafari) {
				window.location = `cowork://login/${lmsToken.get("lmsToken")}`;
			}
			dispatch(byPassUserByLMS({ token: lmsToken.get("lmsToken") }));
		} else if (hasOrbitToken) {
			clearAuthCookies();
			// dispatch(logout());
			dispatch(byPassUserByOrbit({ token: orbitToken.get("orbitToken") }));
		} else {
			clearAuthCookies();
			// dispatch(logout());
		}
	}, []);

	useEffect(() => {
		console.log(isAuthSliceSuccess,'checking')
		if (isAuthSliceSuccess) {
			navigate('/user-dashboard', { replace: true });
		}
	}, [isAuthSliceSuccess]);
	console.log(isAuthSliceSuccess,'checking')

	useEffect(() => {
		const hasLmsToken = lmsToken.get("lmsToken");
		const hasOrbitToken = orbitToken.get("orbitToken");
		if (token && !hasLmsToken && !hasOrbitToken) {
			navigate(isMakersLabTheme || isBloombergTheme ? "/user-dashboard" : isClassroomTheme ? "/classroom-available-rooms" : "/" , { replace: true });
		}
	}, []);
	useEffect(() => {
		if (!byPassMsg) return;
		toast.error(byPassMsg || "Single sign-on failed. Please sign in with your email and password.", {
			toastId: "login-sso-error",
			position: TOAST_POSITION,
			autoClose: TOAST_AUTOCLOSE,
		});
	}, [byPassMsg]);


	const resetPopupHandler = () => {
		setResetPopup(true);
	};

	/**Handling formData with single onChange */
	const onChangeFormData = (event) => {
		const { name, value } = event.target;
		setFormData({
			...formData,
			[name]: value,
		});
		setErrors({ email: "", password: "" });
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			handleSignIn();
		}
	};

	const handleSignIn = () => {
		let newErrors = { email: "", password: "" };

		if (!formData.email) {
			newErrors.email = "Email is required.";
		} else if (!/\S+@\S+/.test(formData.email)) {
			newErrors.email = "Invalid email address.";
		}

		if (!formData.password) {
			newErrors.password = "Password is required.";
		}

		if (newErrors.email || newErrors.password) {
			setErrors(newErrors);
			return;
		}

		console.log("callingnnnngnnn")

		dispatch(loginUser(formData))
	};

	// Surface EVERY auth failure, not just the one hardcoded string this used to
	// match — a wrong password, a locked account or a 500 all used to fail
	// silently. toastId keeps a re-render from stacking a second copy, and
	// clearing the slice afterwards means retrying with the same wrong
	// credentials re-fires instead of going quiet.
	useEffect(() => {
		if (!isAuthSliceError) return;
		toast.error(
			authSliceErrorMessage === "Authentication failed, User not found."
				? "We couldn't find an account with that email."
				: authSliceErrorMessage || "Sign in failed. Please check your email and password.",
			{ toastId: "login-error", position: TOAST_POSITION, autoClose: TOAST_AUTOCLOSE }
		);
		setErrors({ email: "", password: "" });
		dispatch(clearAuthSliceStates());
	}, [isAuthSliceError, authSliceErrorMessage, dispatch]);

	return (
		<LoginWrapper>
			<ResetPasswordPopup
				isActive={resetPopup}
				setResetPopup={setResetPopup}
			/>
			{!token && (
				<WrapperBox className="respPagePad">
					{/* {!isClassroomTheme &&<div
						className="chatWrap"
						onClick={() => navigate("/contact")}
					>
						<p className="dialogueBox">Contact Us</p>

						<img
							src={chatContact}
							alt=""
						/>
					</div>} */}

					{isAuthSliceFetching && <PageLoader />}
					{
						isClassroomTheme ? <EduspaceLogo /> :
						isCoworkTheme ? <CoworkLogoText /> :
						isMakersLabTheme ? <MakersLogoBlack /> :
						isBloombergTheme ? <BloomBergLogoBlack /> :
						<CoworkLogoText />
					}

					<Flexbox className="mt20 loginRow" spaceBW alignCenter gap={24}>
						{
						hideSignInArt ? null :
						isClassroomTheme ? <img src={eduspaceSignInLeft} alt="" className="loginArt" style={SIGNIN_ART_STYLE}/> :
						isCoworkTheme ? <img src={coworkSignInLeft} alt="" className="loginArt" style={SIGNIN_ART_STYLE}/> :
						isMakersLabTheme ? <img src={SignInLeft} alt="" className="loginArt" style={SIGNIN_ART_STYLE}/> :
						isBloombergTheme ? <img src={bloombergSignInLeft} alt="" className="loginArt" style={SIGNIN_ART_STYLE}/> :
						<CoworkLogoText />
					}
					
					{
						<>
							<WrapperBox borderRadius={40} borderColor={globalTheme.colors.nuetral2} boxShadow padding={'40px'} maxWidth={'calc(100% - 60%)'} className="loginCard">

								<Flexbox alignStart column gap={28} className="mb30">
									<img src={Wave} />										
										<Text font30 inter medium black3>Sign in</Text>
									<Text font16 inter medium blue6>Sign in to book a space and start creating.</Text>
								</Flexbox>


								<InputField
									label={"Email Id"}
									placeholder={"Enter registered email Id"}
									onChange={onChangeFormData}
									name="email"
									// isError={errors.email ? true : false}
									// erroMessage={errors.email}
									onKeyDown={handleKeyDown}
								/>
								<InputField
									label={"Password"}
									className='mt24'
									placeholder={"Enter Your Password"}
									onChange={onChangeFormData}
									name="password"
									type={type === true ? "password" : "text"}
									// isError={errors.password ? true : false}
									// erroMessage={errors.password}
									// inputIcon={
									// 	type === true ? "eyeSlash" : "blueEye"
									// }
									onclick={() => setType(!type)}
									onKeyDown={handleKeyDown}
								/>
								<Flexbox flexEnd className="mt15 mb26">
									<StyledLink color={globalTheme.colors.black3} underline
										onClick={resetPopupHandler}
									>

										Forgot password?
									</StyledLink>
								</Flexbox>
								<Button
									primaryFilled
									buttonMd
									fullBtn
									onClick={handleSignIn}
									name={"Sign in"}
								/>

								{/* <Flexbox gap={4} alignCenter justiCenter className="mt30 mb30">
									<Text font16 inter regular nuetral13>Don’t have an account? </Text> <StyledLink fontSize='16px' color={globalTheme.colors.black3} underline>Sign up for free</StyledLink>
								</Flexbox>
								<StyledLink width={'100%'} fontSize='14' underline color={globalTheme.colors.black3} textAlign='center'>Get the android app.</StyledLink> */}
								{/* <a
										className="androidText"
										href="https://play.google.com/store/apps/details?id=com.mastersunion.cowork"
										target="_blank"
									>
										<img src={playStore} alt="" className="playStoreImage" />
									</a> */}

								{/* <a class="androidText" href="https://play.google.com/store/apps/details?id=com.mastersunion.cowork" target="_blank">Get the android app</a> */}
							</WrapperBox>
						</> 
					}
					</Flexbox>
				</WrapperBox>
			)}
		</LoginWrapper>
	);
};

export default Login;
